
  import { defineComponent, PropType } from 'vue';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';

  import type { ProjectPopupState } from './types';

  export default defineComponent({
    name: 'ProjectPopupHeader',
    components: { ButtonComponent },
    props: {
      state: {
        type: Object as PropType<ProjectPopupState>,
        required: true,
      },
    },
    emits: ['countryClick', 'specialTerritoryClick'],
  });
